import React, { useState, useEffect, useRef } from "react";
import "./Counter.css";

const Counter = () => {
    const [countries, setCountries] = useState(1);
    const [customers, setCustomers] = useState(1);
    const [orders, setOrders] = useState(1);
    const [products, setProducts] = useState(1);
    const [startCounting, setStartCounting] = useState(false);

    const counterRef = useRef(null);

    useEffect(() => {
        const currentCounterRef = counterRef.current;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setStartCounting(true);
                } else {
                    setStartCounting(false);
                    resetCounters();
                }
            },
            { threshold: 0.5 }
        );

        if (currentCounterRef) {
            observer.observe(currentCounterRef);
        }

        return () => {
            if (currentCounterRef) {
                observer.disconnect();
            }
        };
    }, []);

    useEffect(() => {
        if (!startCounting) return;

        const interval = setInterval(() => {
            setCountries((prev) => (prev < 50 ? prev + 1 : prev));
            setCustomers((prev) => (prev < 1000 ? prev + 20 : prev));
            setOrders((prev) => (prev < 3500 ? prev + 30 : prev));
            setProducts((prev) => (prev < 30000 ? prev + 40 : prev));
        }, 30); // smooth counting

        return () => clearInterval(interval);
    }, [startCounting]);

    const resetCounters = () => {
        setCountries(1);
        setCustomers(1);
        setOrders(1);
        setProducts(1);
    };

    return (
        <div className="counter-row" ref={counterRef}>
            <div className="counter-box boxrightsideline">
                <h3>Countries Catered</h3>
                <h2>{countries >= 50 ? "50+" : countries}</h2>
            </div>
            <div className="counter-box boxrightsideline">
                <h3>Customers Worldwide</h3>
                <h2>{customers >= 1000 ? "1000+" : customers}</h2>
            </div>
            <div className="counter-box boxrightsideline">
                <h3>Orders Handled Per Year</h3>
                <h2>{orders >= 3500 ? "3500+" : orders}</h2>
            </div>
            <div className="counter-box">
                <h3>MT of Products Handled Per Year</h3>
                <h2>{products >= 30000 ? "30000+" : products}</h2>
            </div>
        </div>
    );
};

export default Counter;
